<template>
    <div>
        <div id="addPhotosAttachments_modal" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!--          Modal Header -->
                    <div class="modal-header" style="text-align: center;">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title text-left">Add Photos & attachments</h4>
                    </div>
                    <!--          End Of Modal Header -->
                    <!-- Modal Body -->
                    <div class="modal-body" style="padding: 30px !important;">
                        <div class="row" >
                            <form id="photosAttachmentUploadForm">
                                <div class="col-sm-12">

                                    <div id="dropzonePhotosAttachmentUploadFormPreview" class="dropzone-previews form-control dz-clickable" style="margin-bottom:20px">
                                        <div class="dz-message"></div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div class="row" v-if=" (type == 'booking' || type == 'invoice' || type == 'estimate' || type == 'inquiry') ">
                            <div class="form-group" style="display:block">
                                <label class="col-md-3"> Service Name :</label>
                                <div class="col-md-9">

                                    <select name="addPhotoAttachments_service_id" id="addPhotoAttachments_service_field" class="select_field form-control" >
                                        <option value="" label="Select one">Select one</option>
                                        <option v-for="service in bookingServices" :value="service.id" :label="service.name">{{ service.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div v-if=" (type == 'service') && ( is_image || is_attachment )" id="attribute"></div>

                        <div class="row addPhotoAttachment_beforeAfter" v-if=" (type == 'booking' || type == 'invoice' || type == 'service') ">
                            <div class="form-group" style="">
                                <label class="col-md-3"> </label>
                                <div class="col-md-9" >
                                    <span v-for="(imageTypeName , imageTypeId) in imageTypes">
                                        <label  class="radio-inline service_mame" :for="`addPhotoAttachments_before_after_job_${imageTypeId}`">
                                            <input type="radio" :image-type-id="imageTypeId" class="addPhotoAttachments_before_after_job" name="addPhotoAttachments_before_after_job"  :id="`addPhotoAttachments_before_after_job_${imageTypeId}`" :value="imageTypeId">{{imageTypeName}}
                                        </label>
                                    </span>
                                    <div class="text-danger text-left" id="addPhotoAttachments_before_after_job_error"></div>
                                </div>
                            </div>
                        </div>



                        <div class="row addPhotoAttachment_textarea" v-if=" type == 'booking' || type == 'invoice'  || type == 'estimate' || type == 'inquiry' ">
                            <div class="form-group" style="">
                                <label class="col-md-3"> {{discussionLabel}}:</label>
                                <div class="col-md-9" >
                                    <textarea name="addPhotoAttachments_discussion" id="addPhotoAttachments_discussion" class="textarea_field form-control" cols="80" rows="5"></textarea>
                                </div>
                            </div>
                        </div>

                        <input type="hidden"  name="addPhotoAttachments_segment" id="addPhotoAttachments_segment" :value="type" />


                        <!-- start Modal footer -->
                        <div class="modal-footer" id="addPhotoAttachments_button_loop">
                            <div class="form-group">
                                <div class="col-md-9"></div>
                                <div class="col-md-3 add_photo_div" id="">
                                    <input type="button" v-show="showSubmitBtn" value="Save Attachment(s)" class="btn btn-primary addPhotoAttachments_save_photo_btn" id="addPhotoAttachments_save_btn" @click="saveAttachment" style="display:block">
                                    <img src="/pic/loading-4.gif" v-show="showLoadingImage" id="addPhotoAttachments_loading_img">
                                </div>
                            </div>
<!--                            <button type="button" data-dismiss="modal" class="btn default">close</button>-->
                        </div>
                        <!-- End Modal footer -->
                    </div>
                    <!-- End Modal Body -->

                </div>
            </div>
        </div>

    </div>
</template>

<script>


import {EventBus} from "../../../../events/event-bus";
import axios from "axios";

export default {
    name: "addPhotoAttachmentsModal",
    components: {},
    props: {

        itemId: {

            required:true
        },
        type:{

            required:true
        },
        addPhotosAndAttachmentsParams:{},
        haveImages:0,
    },
    data() {
        return {
            is_attachment:0,
            is_image:0,
            totalSizes:0,
            filesArray:[],
            photoComponentLoaded:0,
            attachmentsComponentLoaded:0,
            imageTypes:[],
            bookingServices:[],
            postMaxSize: 0,
            showSubmitBtn:false,
            showLoadingImage:false,
            status:'',
            discussionLabel:'Comment',
            // loadDropzoneType:1,
            dropzoneMina:''

        }
    },
    methods:{
        loadDropZoneForPhotos(){
            let error = 0;
            var vm = this;
            // if(vm.dropzoneMina != ''){
            //     Dropzone.autoDiscover = false;
            //     vm.dropzoneMina.destroy()
            // }

            // var photoDropzone1 = new Dropzone("#photosAttachmentUploadForm", {
            vm.dropzoneMina = new Dropzone("#photosAttachmentUploadForm", {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                parallelUploads: 10,
                maxFiles: 100,
                maxFilesize: 10,
                acceptedFiles: "video/*,image/*",
                // acceptedFiles: ".jpeg,.jpg,.png,.gif,.mp3",
                previewsContainer: '#dropzonePhotosAttachmentUploadFormPreview',
                clickable: '#dropzonePhotosAttachmentUploadFormPreview',
                addRemoveLinks: true,
                // capture:"video/*,image/",
                capture:"file",
                // The setting up of the dropzone

                init: function() {
                    this.on("addedfile", async function(file) {
                        if(!error){
                            let validateSize = vm.validateimageSize(file)
                            if(!validateSize) {
                                    this.removeFile(file);
                                    return false;
                            }
                            if (vm.totalSizes > vm.postMaxSize) {
                                console.log(vm.totalSizes, vm.postMaxSize)
                                if(file.type.includes("image")){
                                    this.removeFile(file);
                                    alert(trans("flies_too_big"));
                                    return false;
                                }
                            } else {
                                let filename = await UploadS3TempFile(file);
                                    let fileArray = {
                                        "path":filename,
                                        "size":file.size,
                                        'type':file.type
                                    };
                                    file.id = filename;
                                    vm.filesArray.push(fileArray);
                            }
                            error  = 0;
                        }
                        vm.fetchComponentData();
                    });

                    this.on("removedfile", function(file) {
                        var fileSize = file.size;
                        var MegaSize = fileSize / (1024 * 1024);
                        vm.totalSizes = vm.totalSizes - MegaSize;
                         let index = vm.filesArray.findIndex(fileObj => fileObj.path == file.id );
                        if (index > -1) {
                            vm.filesArray.splice(index, 1);
                        }
                        vm.fetchComponentData();

                    });
                }
            });
        },
        loadDropZoneForAttachments(){
            let error = 0;
            var vm = this;

            // if(vm.dropzoneMina != ''){
            //     Dropzone.autoDiscover = false;
            //     vm.dropzoneMina.destroy()
            // }
            // var photoDropzone2 = new Dropzone("#photosAttachmentUploadForm", {
            vm.dropzoneMina = new Dropzone("#photosAttachmentUploadForm", {
                url: '/',
                autoProcessQueue: false,
                uploadMultiple: true,
                parallelUploads: 10,
                maxFiles: 100,
                maxFilesize: 10,
                previewsContainer: '#dropzonePhotosAttachmentUploadFormPreview',
                clickable: '#dropzonePhotosAttachmentUploadFormPreview',
                addRemoveLinks: true,
                init: function() {
                    this.on("addedfile", async function(file) {
                        if(!error){
                            let validateSize = vm.validateimageSize(file)
                            if(!validateSize) {
                                    this.removeFile(file);
                                    return false;
                            }
                            if (vm.totalSizes > vm.postMaxSize) {
                                if(file.type.includes("image")){
                                    this.removeFile(file);
                                    alert(trans("flies_too_big"));
                                    return false;
                                }
                            } else {
                                // if(vm.type == 'booking'){
                                    let filename = await UploadS3TempFile(file);
                                    let fileArray = {
                                        "path":filename,
                                        "size":file.size,
                                        'type':file.type
                                    };
                                    file.id = filename;
                                    vm.filesArray.push(fileArray);
                                // }
                            }
                            error  = 0;
                        }

                        vm.fetchComponentData();
                    });

                    this.on("removedfile", function(file) {
                        var fileSize = file.size;
                        var MegaSize = fileSize / (1024 * 1024);
                        vm.totalSizes = vm.totalSizes - MegaSize;
                         let index = vm.filesArray.findIndex(fileObj => fileObj.path == file.id );
                        if (index > -1) {
                            vm.filesArray.splice(index, 1);
                        }
                        vm.fetchComponentData();

                    });
                }
            });
        },
        loadPhotoComponent(){
            let vm = this;
            let type = (this.type == 'booking' || this.type == 'estimate' || this.type == 'invoice') ? 'booking' :  this.type ;
            let url = `/webservice/get-photos-parms-for-add-attachment/${type}/${this.itemId}`;
            if(this.haveImages){

                this.postMaxSize = this.addPhotosAndAttachmentsParams.postMaxSize;
                this.bookingServices = this.addPhotosAndAttachmentsParams.booking_services;
                this.imageTypes = this.addPhotosAndAttachmentsParams.image_types;
            }else{

                axios.get(url)
                    .then(function (response) {
                        if(!response.data.data.errors && response.status == '200'){
                            vm.postMaxSize = response.data.data.post_max_size;
                            vm.bookingServices = response.data.data.booking_services;
                            vm.imageTypes = response.data.data.image_types;
                        }
                    })
                    .catch(function (error) {
                        // Handle errors here
                        console.error("Error making request:", error);
                    });
            }

            this.photoComponentLoaded = 1;
        },
        loadAttachmentComponent(){ // not yet
            let vm = this;
            let type = (this.type == 'booking' || this.type == 'estimate' || this.type == 'invoice') ? 'booking' :  this.type ;
            let url = `/webservice/get-attachments-parms-for-add-attachment/${type}/${this.itemId}`;
            if(this.haveImages){

                this.status = this.addPhotosAndAttachmentsParams.status;
                this.loggedUser = this.addPhotosAndAttachmentsParams.logged_user;
            }else{
                axios.get(url)
                    .then(function (response) {
                        if(!response.data.data.errors && response.status == '200'){
                            vm.status = response.data.data.status;
                            vm.loggedUser = response.data.data.logged_user;
                        }

                    })
                    .catch(function (error) {
                        // Handle errors here
                        console.error("Error making request:", error);
                    });
            }

            this.attachmentsComponentLoaded = 1;
        },
        fetchComponentData(){
            let vm = this;
            let has_attachment = 0;
            let files = vm.filesArray;
            for (let i=0; i < files.length; i++){
                let fileType = files[i].type;
                    if(!fileType.includes("image")){
                        has_attachment = 1;
                    }
            }
            if(has_attachment){
                vm.discussionLabel = 'Description'
                vm.is_attachment = 1;
                vm.is_image = 0;
            }else{
                vm.discussionLabel = 'Comment'
                vm.is_attachment = 0;
                vm.is_image = 1;
            }

            if(files.length){
                this.showSubmitBtn=true;
            }else{
                vm.is_attachment = 0;
                vm.is_image = 0;
                this.showSubmitBtn=false;
            }
        },
        resetData(){
            let vm = this;
            if($('[id^="addPhotoAttachments_before_after_job_"]').length){
                $('[id^="addPhotoAttachments_before_after_job_"]').prop('checked', false)
            }

            if($('#addPhotoAttachments_service_field').length){
                $('#addPhotoAttachments_service_field').val('');
            }
            vm.is_image = 0;
            vm.is_attachment = 0;
            vm.filesArray = [];
            $("#dropzonePhotosAttachmentUploadFormPreview .dz-preview").remove();
        },
        saveAttachment(){
            //check if there is attachment
            if(this.filesArray.length){
                this.submitSaveAttachment();
            }else{
                alert('you should upload at least one attachment')
            }

        },
        submitSaveAttachment(){
            this.showSubmitBtn=false;
            this.showLoadingImage=true;

            let is_valid = this.validateSaveAttachment();
            if(is_valid){
                let type = (this.type == 'booking' || this.type == 'invoice' || this.type == 'estimate') ? 'booking' : this.type ;
                let forEstimate = (this.type == 'estimate' || this.type == 'inquiry') ? '?forEstimate=1' : '';
                let url = `/upload-list-of-attachments/${type}/${this.itemId}${forEstimate}`;
                let files = [];
                const formData = new FormData();
                for (let i = 0; i < this.filesArray.length; i++){
                    let x ='{"path": "' + this.filesArray[i].path +'"  ,"size": "' + this.filesArray[i].size + '","type": "' + this.filesArray[i].type + '"}';
                    formData.append('files[]', x);
                }

                let service_id = $("#addPhotoAttachments_service_id").val();
                if(service_id == "undefined" || typeof service_id  == 'undefined'){
                    service_id = '';
                }
                formData.append('segment', $("#addPhotoAttachments_segment").val());
                formData.append('description', $("#addPhotoAttachments_discussion").val());
                formData.append('service_id', service_id);
                formData.append('before_after_job', $(".addPhotoAttachments_before_after_job:checked").attr('image-type-id'));
                formData.append('discussion', $("#addPhotoAttachments_discussion").val());
                // Call your backend endpoint that handles the image upload to S3
                axios.post(url, formData, {
                    responseType: 'json',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                })
                .then((response) => {
                    this.showSubmitBtn=true;
                    this.showLoadingImage=false;
                    EventBus.$emit('photoAttachmentUploaded')
                })
                .catch((error) => {
                    this.showSubmitBtn=true;
                    this.showLoadingImage=false;
                    console.error('Error uploading image:', error);
                });
            }else{
                this.showSubmitBtn=true;
                this.showLoadingImage=false;
            }
        },
        validateSaveAttachment(){
            let valid = true;
            if(!$(".addPhotoAttachments_before_after_job:checked").length){
                $("#addPhotoAttachments_before_after_job_error").html('This field is required')
                if(this.type == 'booking' || this.type == 'invoice'){
                    valid = false;
                }
            }else{
                $("#addPhotoAttachments_before_after_job_error").html('')
            }
            return valid;
        },
        validateimageSize(file){
            let vm = this;
            var fileSize = file.size;
            var MegaSize = fileSize / (1024 * 1024);
            vm.totalSizes = vm.totalSizes + MegaSize;
            console.log(vm.totalSizes, MegaSize)
            if(fileSize > 6*1024*1024) {
                // if(file.type.includes("image")){
                    alert("Please upload a file smaller than 6 MB.");
                    return false;
                // }
                // return true;
            }
            return true;
        }
    },
    computed: {

    },

    mounted(){


        // this.loadDropZone();
    },
    created() {
        let vm = this;

        vm.loadAttachmentComponent();
        vm.loadPhotoComponent();
        EventBus.$on('resetAddPhotoAndAttachmentModal', (type) => {
            Dropzone.autoDiscover = false;
            vm.resetData();
            // vm.loadDropzoneType = type
            if(type == '1'){
                vm.loadDropZoneForPhotos();
            }else{
                vm.loadDropZoneForAttachments();
            }
        })
    }
}
</script>

<style scoped>
.addPhotoAttachment_textarea{
    margin: 21px -15px;
}

.addPhotoAttachment_beforeAfter{
    margin-top: 10px;
}
#dropzonePhotosAttachmentUploadFormPreview, #dropzonePhotosAttachmentUploadFormPreview1{
    height: 100% !important;
}
.service_mame{
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    /*margin: 10px;*/
}
</style>

